import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

const Checkbox = ({
  name,
  className = '',
  disabled = false,
  onChange = () => {},
  onBlur = () => {},
  checked,
  isMixed = false,
  dataPrivate = true
}) => {
  // Set "mixed" checkbox state
  const checkboxRef = useRef(null)

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = isMixed
    }
  }, [isMixed])

  return (
    <label htmlFor={name} className={`form-check-wrapper px-1 ${disabled ? '' : 'pointer'}`}>
      <input
        ref={checkboxRef}
        id={name}
        className={`form-check-input pointer ${className}`}
        type='checkbox'
        aria-label={name}
        name={name}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        checked={checked}
        data-private={dataPrivate}
      />
    </label>
  )
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  checked: PropTypes.bool,
  isMixed: PropTypes.bool,
  dataPrivate: PropTypes.bool
}

export default Checkbox
